import { RadioCheckedIcon, RadioIcon } from './customIcons';

import type { OverWritable } from '../../@types/settings';

export const radio: OverWritable = {
  MuiRadio: {
    defaultProps: {
      icon: <RadioIcon />,
      checkedIcon: <RadioCheckedIcon />,
    },

    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(1),
        svg: {
          fontSize: 24,
          '&[font-size=small]': {
            fontSize: 20,
          },
        },
      }),
    },
  },
};
